import ApplicationController from './application_controller';

export default class extends ApplicationController {

  initialize() {
    this.modal = null
    document.addEventListener("keydown", evt => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
      } else {
        isEscape = (evt.keyCode === 27);
      }
      if (isEscape) {
        this.closeModal();
      }
    });
  }

  closeModal() {
    var modalDialog = document.querySelector('.modal');
    if (modalDialog) {
      modalDialog.remove();
      this.modal = null;
    }
  }

  // Přidejte tento callback - volá se po úspěšném reflexu
  reflexSuccess(element, reflex, noop, reflexId) {
    super.reflexSuccess(element, reflex, noop, reflexId);
    this.focusFirstInput();
  }

  focusFirstInput() {
    if (this.modal) {
      const inputs = this.modal.querySelectorAll('input, textarea');
      const firstVisibleInput = Array.from(inputs).find(input => {
        return !input.hidden &&
          input.type !== 'hidden' &&
          !input.classList.contains('hidden') &&
          !input.disabled &&
          !input.readOnly &&
          input.offsetParent !== null;
      });

      if (firstVisibleInput) {
        setTimeout(() => firstVisibleInput.focus(), 100);
      }
    }
  }

  showTextInModal(event) {
    event.preventDefault();

    var modal = document.createElement('div');
    modal.id = event.currentTarget.dataset.modalId;
    modal.classList.add('modal');
    this.modal = modal;

    // Parse and format JSON text
    let jsonText;
    try {
      jsonText = JSON.parse(event.currentTarget.dataset.modalText);
      jsonText = JSON.stringify(jsonText, null, 2);
    } catch (e) {
      jsonText = event.currentTarget.dataset.modalText;
    }
    modal.innerHTML = '<div class="modal-dialog"><pre>' + jsonText + '</pre></div>';

    document.body.appendChild(modal);
  }

  show(event) {
    event.preventDefault();

    var modal = document.createElement('div');
    modal.id = event.currentTarget.dataset.modalId;
    modal.classList.add('modal');
    modal.innerHTML = '<div class="modal-dialog"><div class="spinner-border"></div></div>';

    this.modal = modal;

    document.body.appendChild(modal);
  }

  showLoading(event) {
    const overlay = document.createElement('div');
    overlay.id = 'loading-overlay';
    overlay.innerHTML = '<div class="spinner-border"></div>';
    document.body.appendChild(overlay);
  }

  close(event) {
    event.preventDefault();
    event.currentTarget.closest('.modal').remove();
    this.modal = null;
  }

  showBatchProgress(total, options = {}) {
    this.closeModal();

    const { readOnly = false, userName = null } = options;
    const userLine = userName
      ? `<p class="batch-progress__user">${userName}</p>`
      : '';

    const modal = document.createElement('div');
    modal.id = 'batch-progress-modal';
    modal.classList.add('modal', 'modal--batch-progress');
    modal.innerHTML = `
      <div class="modal-dialog">
        <div class="batch-progress">
          <p class="batch-progress__title">${this.batchProgressTitle || 'Vkládání senzorů...'}</p>
          ${userLine}
          <div class="batch-progress__bar-wrapper">
            <div class="batch-progress__bar" id="batch-progress-bar" style="width: 0%"></div>
          </div>
          <p class="batch-progress__counter">
            <span id="batch-progress-current">0</span> / <span id="batch-progress-total">${total}</span>
          </p>
          <div id="batch-progress-errors" class="batch-progress__errors hidden"></div>
        </div>
      </div>
    `;
    this.modal = modal;
    document.body.appendChild(modal);
  }

  updateBatchProgress(current, total) {
    const bar = document.getElementById('batch-progress-bar');
    const currentEl = document.getElementById('batch-progress-current');
    const totalEl = document.getElementById('batch-progress-total');

    if (!bar || !currentEl) return;

    const pct = total > 0 ? Math.round((current / total) * 100) : 0;
    bar.style.width = pct + '%';
    currentEl.textContent = current;
    if (totalEl) totalEl.textContent = total;

    if (current >= total) {
      const hasErrors = document.getElementById('batch-progress-errors')?.children.length > 0;
      if (!hasErrors) {
        setTimeout(() => this.closeModal(), 600);
      }
    }
  }

  showBatchProgressError(message) {
    const errorsEl = document.getElementById('batch-progress-errors');
    if (!errorsEl) return;

    const item = document.createElement('p');
    item.classList.add('batch-progress__error-item');
    item.textContent = message;
    errorsEl.appendChild(item);
    errorsEl.classList.remove('hidden');
  }
}
